<template>
  <div id="page-index">
    <div class="page-title">Deposit Payment</div>
    <div class="totalCol">
      <span>&pound; </span>
      <strong>{{ (priceTotal / 100).toFixed(2) }}</strong>
    </div>
    <div class="paymentMethod-module">
      <h6>Payment method</h6>
      <ul class="preference-list">
        <span v-if="this.opayo_set_status == 1">
          <li class="opayborder">
            <label for="method" class="preferenceLabel">
              <span> <a-icon type="credit-card" />Credit/Debit Card </span>
            </label>
            <div class="checkbox checkbox-orange">
              <input
                id="method"
                type="radio"
                name="card"
                value="0"
                checked="checked"
                @click="newCard"
              />
              <label for="method"></label>
            </div>
          </li>
        </span>
        <li v-if="this.viva_set_status == 1">
          <label for="method_" class="preferenceLabel">
            <span> <a-icon type="credit-card" />Credit/Debit Card </span>
          </label>
          <div class="checkbox checkbox-orange">
            <input
              id="method_"
              type="radio"
              name="card"
              value="2"
              @click="vivawallet"
            />
            <label for="method_"></label>
          </div>
        </li>
      </ul>
    </div>
    <div class="absBottomButton">
      <button
        class="button btn-yellow payBtn"
        id="payBtn"
        type="button"
        @click="go2SagePayClick()"
      >
        Pay
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "SelectCard",
  data() {
    return {
      opayo_set_status: 1,
      viva_set_status: 1,
      types: "opay",
      vivaUrl: process.env.VIVA,
      vivalCode: "",
      reservation_id: "",
      depositPrice: "",
      store_id: "",
    };
  },
  methods: {
    newCard() {
      console.log("opay");
      this.types = "opay";
    },
    vivawallet() {
      console.log("viva");
      this.types = "viva";
    },
    go2SagePayClick() {
      //localStorage.setItem('priceTotal',0)
      if (this.types == "opay") {
        this.$router.push({
          path: "/opayo",
        });
      } else {
        let postData = {
          reserve_id: this.reservation_id,
          amount: this.depositPrice,
          source: 1,
          store_id: this.store_id,
        };
        axios
          .post(process.env.API_URL + "htmlReserve/vivaPayment", postData)
          .then((res) => {
            console.log(res.data.data);
            if (res.data.code == 200) {
              localStorage.setItem("store_data", "");
              localStorage.setItem("priceTotal", "");
              localStorage.setItem("reservation_id", "");
              localStorage.setItem("opayo_set_status", "");
              localStorage.setItem("viva_set_status", "");
              localStorage.setItem("depositPrice", "");
              localStorage.setItem("store_id", "");
              window.location = this.vivaUrl + res.data.data;
            }
          });
      }
    },
  },
  created() {
    this.priceTotal = localStorage.getItem("priceTotal");
    this.reservation_id = localStorage.getItem("reservation_id");
    this.opayo_set_status = localStorage.getItem("opayo_set_status");
    this.viva_set_status = localStorage.getItem("viva_set_status");
    this.depositPrice = localStorage.getItem("depositPrice");
    this.store_id = localStorage.getItem("store_id");
  },
};
</script>

<style>
#page-index {
  background: #f9f9f9;
  height: 100%;
}

.page-title {
  background-color: #fff;
  border-bottom: 1px solid #efefef;
  padding: 10px 0 10px;
  font-size: 16px;
  position: absolute;
  text-align: center;
  top: 0;
  left: 50%;
  -webkit-transform: translate(-50%, 0);
  -ms-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  width: 100%;
  max-width: 100%;
  height: 45px;
  z-index: 10;
}

.totalCol {
  padding: 20% 0 20px;
  text-align: center;
}

.totalCol span {
  font-weight: 700;
  font-size: 20px;
}

.totalCol strong {
  font-size: 34px;
}

.paymentMethod-module {
  background: #fff;
  max-height: 220px;
  overflow-y: scroll;
}

.paymentMethod-module h6 {
  display: block;
  text-align: left;
  padding: 10px 20px;
}

.preference-list {
  padding: 0 20px;
}

.paymentMethod-module .preference-list li {
  position: relative;
  padding: 10px 10px 0 0;
  border-bottom: 1px dashed #efefef;
  display: grid;
  grid-template-columns: calc(100% - 70px) 60px;
  grid-auto-flow: dense;
  grid-column-gap: 10px;
}

.paymentMethod-module .preference-list li i {
  margin-right: 10px;
}

.checkbox-orange {
  position: absolute;
  right: 0px;
  bottom: 0px;
}

.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.absBottomButton {
  position: absolute;
  width: 100%;
  bottom: 5%;
}

.payBtn {
  display: block;
  width: 90%;
  margin: 0 auto;
  border-radius: 30px;
  /* background: linear-gradient(
    180deg,
    rgba(255, 231, 116, 1) 0%,
    rgba(255, 202, 64, 1) 100%
  ); */
  color: #000;
  font-weight: 600;
  padding: 10px 0;
  border: none;
  outline: none;
  background-color: var(--brandColor);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/page/Card/SelectCard.vue